import { createSelector } from "reselect";
import getProject from "./get_project";

const getDefaultFloorId = createSelector([
  getProject,
], (project) => project?.defaultFirebaseFloorId || null);

export default getDefaultFloorId;
